import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import PropertiesListFilters from './PropertiesListFilters';
import PropertyGroupField from 'components/field/PropertyGroupsField';
import PropertyListIcon from './PropertyListIcon';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deleteProperty } from 'store/actions/properties/deleteProperties';
import { fetchProperties } from 'store/actions/properties/fetchProperties';

const PropertiesList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <PropertiesListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchProperties }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                sort={ {
                    field: 'name',
                } }
                updateQuery={ updateQuery }
            >
                <Table>
                    <TextField
                        { ...props }
                        column={ {
                            sortable: true,
                        } }
                        label='resources.properties.fields.name'
                        source='name'
                    />

                    <PropertyListIcon
                        column={ {
                            sortable: false,
                        } }
                        label='resources.properties.fields.icon'
                        source='id'
                        style={ { padding: 0, textAlign: 'center' } }
                    />

                    <PropertyGroupField
                        column={ {
                            align: 'center',
                            sortable: false,
                            width: '10%',
                        } }
                        display='name'
                        label='resources.properties.fields.property_group_id'
                        source='property_group_id'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deleteProperty } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

PropertiesList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(PropertiesList);



// WEBPACK FOOTER //
// ./src/pages/properties/list/PropertiesList.js